import { Step } from "react-joyride";
import {
  ADD_PRODUCT_CONTENT,
  clickElement,
  jobContinueStep,
  LOOK_ONLY,
  mapSteps,
  NO_BACK,
  productSectionSteps,
  selectProductStep,
  totalsAndSendSteps,
  waitForSettled,
  WAIT_FOR_USER,
  withTourDefaults,
} from "./DraftPageTour.shared";

const openJobAddressMap = async () => {
  if (document.querySelector(".tour-map-address-window")) return;
  clickElement(".tour-job-address");
  await waitForSettled(".tour-map-address-window");
};

const steps: Step[] = [
  {
    id: "job-name",
    target: ".tour-job-name",
    content: "Give your job a name.",
    data: { requireValue: ".tour-job-name input" },
    disableFocusTrap: true,
    targetWaitTimeout: 3000,
    ...NO_BACK,
  },
  {
    id: "job-address",
    target: ".tour-job-address",
    content: "Click here to open Maps and add an address to your Job/Stage.",
    ...LOOK_ONLY,
  },
  {
    id: "add-job",
    target: ".tour-add-job-button",
    content: "You can add and estimate multiple Jobs within one Proposal.",
    ...LOOK_ONLY,
  },
  ...mapSteps(openJobAddressMap),
  jobContinueStep,
  selectProductStep,
  {
    id: "add-product",
    target: ".tour-add-product-to-proposal",
    content: ADD_PRODUCT_CONTENT,
    ...WAIT_FOR_USER,
    buttons: ["back", "close"],
  },
  ...productSectionSteps({ targetWaitTimeout: 8000 }),
  ...totalsAndSendSteps,
];

const createProposalsDraftPageTourSteps: Step[] = withTourDefaults(steps);

export default createProposalsDraftPageTourSteps;
